import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  class: "home-section",
  id: "vs-home-comments"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "home-comments-title" }, "Opinião dos nossos pacientes", -1)
const _hoisted_3 = { class: "home-comments-cards" }
const _hoisted_4 = { class: "home-comments-card" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "home-comments-card-container" }
const _hoisted_7 = { class: "home-comments-card-message" }
const _hoisted_8 = { class: "home-comments-card-name" }


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const cards = [
  {
    name: "Pâmela Mozart",
    message:
      "Plataforma super intuitiva, não tive qualquer dificuldade em realizar a compra dos meus exames. Além disso, o orçamento por laboratório foi que mais me chamou atenção. Gostei muito da praticidade e facilidade, recomendo.",
    image: "female-comment.jpg",
  },
  {
    name: "André Junhson",
    message:
      "Realizei meu cadastro, pesquisei um exame, selecionei o dia da minha preferência, escolhi a clínica e fiz o pagamento direto pelo site. Tudo fácil, rápido e seguro! Super recomendo!!!",
    image: "male-comment.jpg",
  },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(cards, (card) => {
        return _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            class: "home-comments-card-image",
            src: require(`@/assets/images/${card.image}`),
            alt: "imagem"
          }, null, 8, _hoisted_5),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("p", _hoisted_7, _toDisplayString(card.message), 1),
            _createElementVNode("h6", _hoisted_8, _toDisplayString(card.name), 1)
          ])
        ])
      }), 64))
    ])
  ]))
}
}

})